/**
 * Корневой предохранитель Mini App (2026-09-25): сбой отрисовки или не догрузившийся кусок
 * приложения (после выкатки старые файлы удаляются) больше не оставляют лиду белый экран.
 * Показываем «Обновить» и сообщаем об ошибке в журнал лида.
 */
import React from 'react';
import { reportClientError } from './lib/api.js';

interface State {
  failed: boolean;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: unknown): void {
    reportClientError({
      kind: 'render',
      message: error instanceof Error ? error.message : String(error),
      ...(error instanceof Error && error.stack ? { stack: error.stack } : {}),
    });
  }

  override render(): React.ReactNode {
    if (!this.state.failed) return this.props.children;
    // тексты словаря могут быть недоступны (они тоже часть упавшего приложения) —
    // короткая надпись на двух языках и одна кнопка
    return (
      <div className="app-crash" style={{ padding: 32, textAlign: 'center', color: '#fff' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
        <div style={{ marginBottom: 20 }}>Что-то пошло не так · Something went wrong</div>
        <button type="button" className="btn btn-primary" onClick={() => location.reload()}>
          ↻ Обновить · Reload
        </button>
      </div>
    );
  }
}
